// Components
import Drawer from "@mui/material/Drawer";
import FilterSidebar from "../FilterSidebar";
import { FilterGroupType } from "../FilterSection/FilterSection";

type FilterDrawerType = {
  isOpen: boolean;
  onClose: () => void;
  hasData: boolean;
  examTypeFilter: FilterGroupType;
  examDateFilter: FilterGroupType;
  examEyeFilter: FilterGroupType;
};

// Mobile-only drawer for FilterSidebar
const FilterDrawer = ({
  isOpen,
  onClose,
  hasData,
  examTypeFilter,
  examDateFilter,
  examEyeFilter,
}: FilterDrawerType) => {
  return (
    <Drawer
      anchor="left"
      open={isOpen}
      onClose={onClose}
      disableRestoreFocus
      // Add to zIndex so it appears above the modal
      sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
      PaperProps={{
        sx: {
          display: "flex",
          width: { xs: "100vw", sm: "350px" },
        },
      }}
    >
      <FilterSidebar
        hasData={hasData}
        isCollapsed={false}
        onToggleCollapse={onClose}
        examTypeFilter={examTypeFilter}
        examDateFilter={examDateFilter}
        examEyeFilter={examEyeFilter}
      />
    </Drawer>
  );
};

export default FilterDrawer;
